var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape14 = function SvgShape14(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.515 110.515c-32.97 32.97-76.942 42.454-98.213 21.183S.515 66.455 33.485 33.485s76.942-42.454 98.213-21.183 11.787 65.243-21.183 98.213",
    opacity: 0.1
  })));
};
export default SvgShape14;